import { useRecordContext } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { Tab } from 'shared/mui/Tab/Tab';
import { TabPanel } from 'shared/mui/TabPanel/TabPanel';
import { Tabs } from 'shared/mui/Tabs/Tabs';
import { useGetFiles } from 'shared/widgets/TableFileViewer/hooks/useGetFiles';
import { BankOperation } from 'types/embedded/bankOperation';

import { RequestsBankOpsShowTabsComments } from './RequestsBankOpsShowTabsComments';
import { RequestsBankOpsShowTabsFiles } from './RequestsBankOpsShowTabsFiles';
import { RequestsBankOpsShowTabsHistory } from './RequestsBankOpsShowTabsHistory';
import { RequestsBankOpsShowTabsInfo } from './RequestsBankOpsShowTabsInfo';
import { RequestsBankOpsShowTabsRelated } from './RequestsBankOpsShowTabsRelated';

type Props = {
  initialTab?: number;
  handleTabChange?: (newTab: number) => void;
};

export const RequestsBankOpsShowTabs: React.FC<Props> = ({ initialTab = 0, handleTabChange }) => {
  const record = useRecordContext<BankOperation>();
  const { data: files } = useGetFiles('bank_operation', record?.originId);

  const handleChange = (_e: React.SyntheticEvent, newValue: number) => {
    handleTabChange?.(newValue);
  };

  return (
    <>
      <Box sx={{ width: '100%', marginBottom: '24px' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            onChange={handleChange}
            sx={{ '& .MuiTab-root': { maxWidth: 'none', whiteSpace: 'nowrap' } }}
            value={initialTab}
          >
            <Tab label="Основные настройки" value={0} />
            <Tab label={`Файлы (${files?.length || 0})`} value={1} />
            <Tab
              label={`Комментарии при изменении статуса (${record?.commentCount || 0})`}
              value={2}
            />
            {record?.related && <Tab label="Смежная заявка" value={3} />}
            <Tab label="История" value={4} />
          </Tabs>
        </Box>
      </Box>
      <TabPanel index={0} value={initialTab}>
        <RequestsBankOpsShowTabsInfo />
      </TabPanel>
      <TabPanel index={1} value={initialTab}>
        <RequestsBankOpsShowTabsFiles />
      </TabPanel>
      <TabPanel index={2} value={initialTab}>
        <RequestsBankOpsShowTabsComments />
      </TabPanel>
      {record?.related && (
        <TabPanel index={3} value={initialTab}>
          <RequestsBankOpsShowTabsRelated />
        </TabPanel>
      )}
      <TabPanel index={4} value={initialTab}>
        <RequestsBankOpsShowTabsHistory />
      </TabPanel>
    </>
  );
};
